<template>
  <div class="company-container">
    <!-- 轮播图区域 -->
    <image-carousel :images="images" />

    <!-- 公司简介区域 -->
    <section class="about-section">
      <div class="about-inner">
        <header class="about-head">
          <span class="about-pill">公司介绍</span>
          <h2 class="about-title">聚汇盈（北京）科技有限公司</h2>
          <p class="about-sub">Juhuiying (Beijing) Technology Co., Ltd.</p>
        </header>

        <!-- 杂志式：图文交错长版 -->
        <div class="mag-grid">
          <!-- 行一：图1 + 第1段 -->
          <div class="mag-row">
            <figure class="mag-media">
              <img
                  src="https://youqixing.oss-cn-beijing.aliyuncs.com/49a863ef0c14fbcaacefb4897d1085b.png"
                  alt="聚汇盈公司介绍配图一"
                  loading="lazy"
              >
            </figure>
            <p class="about-para">
              聚汇盈（北京）科技有限公司成立于 <span class="hl">2022</span> 年，办公地址位于大兴区星光视界中心。作为一家新兴企业，我们始终秉持<b>创新、高效、共赢</b>的发展理念，致力于在激烈的市场竞争中开拓进取。
            </p>
          </div>

          <!-- 行二：第2段 + 图2（左右互换，形成错落感） -->
          <div class="mag-row mag-flip">
            <figure class="mag-media">
              <img
                  src="https://youqixing.oss-cn-beijing.aliyuncs.com/d04b53259b304d24a5fff1e6375246f.png"
                  alt="聚汇盈公司介绍配图二"
                  loading="lazy"
              >
            </figure>
            <p class="about-para">
              在业务领域，公司充分发挥自身优势，积极拓展多元业务。我们拥有一支专业能力强、富有创造力与责任心的团队，成员们凭借丰富的行业经验和敏锐的市场洞察力，不断推动业务的发展与创新。自成立以来，公司与北京优启星健康科技有限公司在<b>儿童孤独症领域</b>和<b>感统失调康复</b>等方面取得了显著进展，赢得了客户的认可与信赖。
            </p>
          </div>

          <!-- 收尾段：整宽居中 -->
          <p class="about-para mag-tail">
            未来，聚汇盈（北京）有限公司将继续深耕核心业务，不断提升服务品质与专业水平，努力成为行业内具有影响力的领军企业，为客户、员工和社会创造更大的价值。
          </p>
        </div>
      </div>
    </section>
    <el-backtop :right="24" :bottom="56"></el-backtop>
  </div>
</template>

<script>
import ImageCarousel from './ImageCarousel.vue'

export default {
  name: 'CompanyIntro',
  components: {
    ImageCarousel
  },
  data() {
    return {
      images: [
        { url: require('../assets/img/gun1.png'), alt: '图片1' },
        { url: require('../assets/img/gun2.png'), alt: '图片2' },
        { url: require('../assets/img/gun3.png'), alt: '图片3' },
      ]
    }
  }
}
</script>

<style scoped>
.components,
.company-container {
  width: 100%;
  overflow-x: hidden;
  padding-bottom: 80px;
  box-sizing: border-box;
}

/* 轮播图的样式在 ImageCarousel.vue 里（两页共用） */

/* ================= 公司简介区域 ================= */
.about-section {
  width: 100%;
  box-sizing: border-box;
  margin-top: 46px;
  padding: 68px 24px 76px;
  background: linear-gradient(180deg, #f6fbf7 0%, #ffffff 55%);
}

.about-inner {
  max-width: 980px;
  margin: 0 auto;
}

.about-head {
  text-align: center;
  margin-bottom: 44px;
}

.about-pill {
  display: inline-block;
  padding: 6px 20px;
  font-size: 15px;
  letter-spacing: 0.26em;
  text-indent: 0.26em; /* 抵消末字字距，让文字视觉居中 */
  color: #15803d;
  background: #e9f7ee;
  border: 1px solid #cfece0;
  border-radius: 999px;
}

.about-title {
  margin: 20px 0 12px;
  font-size: clamp(2.2rem, 4.2vw, 3.4rem);
  font-weight: 800;
  color: #1f2937;
  letter-spacing: 0.04em;
}

.about-sub {
  margin: 0;
  font-size: 14px;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: #9ca3af;
}

.about-para {
  margin: 0 0 1.5em;
  font-size: clamp(16px, 1.3vw, 18px);
  line-height: 2.05;
  color: #374151;
  text-align: justify;
}

/* 杂志式长版：图文交错 */
.mag-grid {
  display: grid;
  gap: clamp(56px, 8vw, 100px);
}

.mag-row {
  display: grid;
  grid-template-columns: 1.08fr 1fr;
  gap: clamp(40px, 6vw, 78px);
  align-items: center;
}

/* 第二行左右互换，形成错落版式 */
.mag-flip .mag-media {
  order: 2;
}

.mag-media {
  margin: 0;
}

.mag-media img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 18px;
  box-shadow: 0 16px 38px rgba(17, 24, 39, 0.14);
}

/* 行内段落垂直居中、去掉行底距（间距交给 mag-grid） */
.mag-row .about-para {
  margin-bottom: 0;
}

/* 收尾段 */
.mag-tail {
  max-width: 880px;
  margin: 0 auto;
  text-align: center;
  font-size: clamp(16px, 1.35vw, 19px);
  line-height: 2;
  color: #4b5563;
}

.about-para b,
.about-para .hl {
  color: #15803d;
  font-weight: 700;
}

@media (max-width: 900px) {
  /* 单列：每行图在上、文在下 */
  .mag-row {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .mag-flip .mag-media {
    order: 0;
  }
}

@media (max-width: 560px) {
  /* 底部留白：区块自身 44 + 容器 36 = 80px（原来 52 + 80 = 132px，小屏上空一大截） */
  .company-container {
    padding-bottom: 36px;
  }

  /* 轮播图与「公司介绍」之间只留 14px。之前这里看起来空一大块，真正的原因是
     Element 对 type="card" 强制把指示器渲染成 --outside（正常流），在轮播下方
     白占了 30px；已在 ImageCarousel.vue 用 indicator-position="none" 去掉，
     所以这里不需要再留补偿间距，改大反而会重新变空。 */
  .about-section {
    margin-top: 14px;
    padding: 26px 18px 44px;
  }

  .about-head {
    margin-bottom: 30px;
  }

  /* 公司全名 12 个字，窄屏必须排成一行才不会看着不对称：
     能折的位置只有「聚汇盈（北京）」之后（右括号不能出现在行首），折出来是 7:5，
     而且第一行以细括号收尾，视觉上比 7:5 还更偏，所以干脆一整行。
     实测每个字占 1.1267em（含 0.04 字距），整名共 13.52em；
     320px 可用 284px ⇒ 字号上限 21px，取 6vw（=19.2px）留约 8% 余量。 */
  .about-title {
    margin-top: 14px;
    font-size: clamp(1.05rem, 6vw, 1.75rem);
  }

  /* 英文副标题：14px / 0.3em 在 390px 下会折成两行，尾行只剩「CO., LTD.」，
     收小字号与字距后正好排成完整一行 */
  .about-sub {
    font-size: 12px;
    letter-spacing: 0.08em;
  }

  .mag-grid {
    gap: 48px;
  }

  .mag-row {
    gap: 18px;
  }

  .mag-media img {
    border-radius: 14px;
  }

  .about-para {
    font-size: 17px;
    line-height: 1.9;
  }
}
</style>